import React from 'react';
import { Link } from 'react-router-dom';

const BrandHeader = () => {
  return (
    <div className="text-center space-y-6 mb-8">
      {/* Company Logo */}
      <Link to="/login" className="inline-flex items-center justify-center">
        <div className="w-32 h-16 flex items-center justify-center">
          <img 
            src="/assets/images/JEWELTHREAD_Vector-1757685590897.png" 
            alt="JewelThread Logo"
            className="h-full w-auto object-contain"
            style={{ backgroundColor: 'transparent' }}
          />
        </div>
      </Link>

      {/* Sign in Header */}
      <div className="space-y-1">
        <h2 className="text-xl font-heading text-foreground">
          Sign in to your Account
        </h2>
      </div>
    </div>
  );
};

export default BrandHeader;